import { Select } from '@shared/ui/components/Select';

import { FilterConfiguration } from './DataTable.types';

type DataTableSelectFilterProps = {
  filter: FilterConfiguration;
  value: string | number | null;
  onChange: (value: string | number | null) => void;
};

export function DataTableSelectFilter({ filter, value, onChange }: DataTableSelectFilterProps) {
  return (
    <Select
      options={filter.options ?? []}
      value={value}
      onChange={onChange}
      className="flex border-none rounded-none bg-white min-w-[12rem]"
    />
  );
}
